<template>
  <v-app >
    <div >
      <v-app-bar
        v-show="!hiddenToolbar"
        fixed
        app
        color="primary"
        dense
        dark
        class="hidden-print-only"
      >
        <v-app-bar-nav-icon
          @click.stop="drawer = !drawer"
          v-if="!showComputer"
        ></v-app-bar-nav-icon>
        <!-- <v-toolbar flat dense color="primary" :hidden="hiddenToolbar" dark app> -->
        <!-- <v-btn v-if="showComputer" icon text @click="$router.back()">
          <v-icon>arrow_back</v-icon>
        </v-btn> -->
        <v-toolbar-title v-if="showComputer">
          <v-btn  text  @click="clickHome" style="text-transform: none" router :to="clickHome">
            <span > Dashboard </span>
          </v-btn>
        </v-toolbar-title>
        <v-toolbar-title v-if="!showComputer">
          <v-btn router :to="clickHome" text @click="clickHome" style="text-transform: none">
            <span> Dashboard </span>
          </v-btn>
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-toolbar-items>
          <v-menu offset-y left v-if="showComputer">
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on">
                <v-icon>account_box</v-icon>
              </v-btn>
            </template>
            <v-card class="mx-auto pr-1 pl-1" max-width="300" tile>
              <v-list dense shaped>
                <v-subheader>Profile</v-subheader>
                <v-list-item-group color="primary">
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon>account_circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="profileName"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                    <v-list-item router :to="item.value" v-for="(item, index) in profileMenuItem" text :key="index" @click="changeRouter(item.value)">
                      <v-list-item-icon>
                        <v-icon v-text="item.icon"></v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.title"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-menu>
        <v-btn router :to="'/osnoti'" text @click="changeRouter('/osnoti')" v-if="uiAccept.history"><v-icon>notifications</v-icon></v-btn>
          <v-menu offset-y left v-if="showComputer && (uiAccept.debtorcreditor || uiAccept.osdetail || uiAccept.delivery) ">
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on">
                <v-icon class="d-md-none">library_books</v-icon>
                <span class="ml-2 d-none d-sm-flex">Statement</span>
                <v-icon class="d-none d-sm-flex">expand_more</v-icon>
              </v-btn>
            </template>
            <v-card class="mx-auto pr-1 pl-1" max-width="300" tile>
              <v-list dense>
                <v-subheader>Statement</v-subheader>
                <v-list-item-group color="primary">
                  <v-list-item
                  router :to="item.value"
                    v-for="(item, index) in statement"
                    :key="index"
                    @click="changeRouter(item.value)"
                  >
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="item.title"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-menu>
          <v-menu offset-y left v-if="showComputer && (uiAccept.complete || uiAccept.salereport || uiAccept.incomereport || uiAccept.expensereport || uiAccept.profitandloss || uiAccept.ridertimereport || uiAccept.rideranalyzereport || uiAccept.restanalyzereport)">
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on">
                <v-icon class="d-md-none">assessment</v-icon>
                <span class="ml-2 d-none d-sm-flex">Report</span>
                <v-icon class="d-none d-sm-flex">expand_more</v-icon>
              </v-btn>
            </template>
            <v-card class="mx-auto pr-1 pl-1" max-width="300" tile>
              <v-list dense>
                <v-subheader>All Report</v-subheader>
                <v-list-item-group color="primary">
                  <v-list-item
                  router :to="item.value" 
                    v-for="(item, index) in report"
                    :key="index"
                    @click="changeRouter(item.value)"
                  >
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="item.title"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-menu>
          <v-menu offset-y left v-if="showComputer && (uiAccept.neworder || uiAccept.orderlist || uiAccept.dailyriderlist || uiAccept.dailyriderpaylist || uiAccept.dailyrestaurantlist) ">
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on">
                <v-icon class="d-md-none">post_add</v-icon>
                <span class="ml-2 d-none d-sm-flex">Order</span>
                <v-icon class="d-none d-sm-flex">expand_more</v-icon>
              </v-btn>
            </template>
            <v-card class="mx-auto pr-1 pl-1" max-width="300" tile>
              <v-list dense>
                <v-subheader>Order/Task</v-subheader>
                <v-list-item-group color="primary">
                  <v-list-item
                  router :to="item.value"
                    v-for="(item, index) in order"
                    :key="index"
                    @click="changeRouter(item.value)"
                  >
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="item.title"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-menu>
          <v-menu offset-y left v-if="showComputer && (uiAccept.payment || uiAccept.income || uiAccept.expense || uiAccept.finance) " >
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on">
                <v-icon>account_balance_wallet</v-icon>
              </v-btn>
            </template>
            <v-card class="mx-auto pr-1 pl-1" max-width="300" tile>
              <v-list dense>
                <v-subheader>Income/Expense</v-subheader>
                <v-list-item-group color="primary">
                  <v-list-item
                  router :to="item.value"
                    v-for="(item, index) in incomeMeuns"
                    :key="index"
                    @click="changeRouter(item.value)"
                  >
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="item.title"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-menu>
          
          <v-menu
            offset-y
            left
            v-if="showComputer && (uiAccept.dailypercent || uiAccept.restaurant || uiAccept.useraccount || uiAccept.companyprofile || uiAccept.rating)"
          >
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on">
                <v-icon>settings</v-icon>
              </v-btn>
            </template>
            <v-card class="mx-auto pr-1 pl-1" max-width="300" tile>
              <v-list dense>
                <v-subheader>GENERAL SETTINGS</v-subheader>
                <v-list-item-group color="primary">
                  <v-list-item
                   router :to="item.value"
                    v-for="(item, index) in settingMenuItem"
                    :key="index"
                    @click="changeRouter(item.value)"
                  >
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="item.title"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-menu>
        </v-toolbar-items>
      </v-app-bar>
      <v-navigation-drawer v-model="drawer" fixed temporary>
        <v-list-item-group active-class="primary--text text--accent-4">
          <v-list-item>
            <v-list-item-avatar>
              <v-img src="/info/logo.png"></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title
                ><h1>{{ profileName }}</h1></v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list dense>
            <v-list-item
              v-for="item in drawerList"
              :key="item.title"
              link
              @click="clickDrawer(item)"
              active-class="deep-purple--text text--accent-4"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-list-item-group>
        <template v-slot:append>
          <div class="pa-2">
            <v-btn
              class="red--text"
              block
              rounded
              outlined
              @click="changeRouter('/logout')"
            >
              <v-icon>logout</v-icon>Logout
            </v-btn>
          </div>
        </template>
      </v-navigation-drawer>
    </div>
    <v-content >
      <v-container fluid class="ma-0 pa-0 white">
        <v-progress-linear
          v-if="loading"
          fixed
          :indeterminate="loading"
          color="accent"
        ></v-progress-linear>
        <router-view :hideToolbar="hideToolbar" />
      </v-container>
    </v-content>
    <div>
      <v-dialog v-model="logoutModel" persistent max-width="350">
        <v-card>
          <v-card-title class="title"
            >Are you sure want to Logout?</v-card-title
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="logoutModel = false"
              >Cancel</v-btn
            >
            <v-btn color="primary" depressed @click="logout">logout</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div>
      <v-dialog v-model="passwordModel" persistent max-width="290">
        <v-form ref="form" v-model="valid">
          <v-card>
            <v-card-title class="headline">Change Password?</v-card-title>
            <v-card-text class="pb-0">
              <v-text-field
                :append-icon="showOld ? 'visibility' : 'visibility_off'"
                :type="showOld ? 'text' : 'password'"
                @click:append="showOld = !showOld"
                :rules="passwordOldRule"
                v-model="password.old"
                label="Old Password"
                name="oldPassword"
                placeholder=" "
                outlined
                dense
              ></v-text-field>
              <v-text-field
                :append-icon="showNew ? 'visibility' : 'visibility_off'"
                :type="showNew ? 'text' : 'password'"
                @click:append="showNew = !showNew"
                :rules="passwordNewRule"
                v-model="password.new"
                label="New Password"
                name="newPassword"
                placeholder=" "
                outlined
                dense
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="cancelChangePassword"
                >Cancel</v-btn
              >
              <v-btn
                color="primary"
                :disabled="!valid"
                depressed
                @click="changePassword"
                >Change</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </div>
    <div>
           <v-overlay :value="loading" z-index="1000">
           <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
    </div>
  </v-app>
</template>
<script>
import accountUserService from "../src/service/AccountUserService";
import axios from "../src/config";

export default {
  data() {
    return {
      report: [],
      statement: [ ],
      order: [],
      orderDelivery: [
        {
          title: "Order List",
          icon: "assignment_turned_in",
          value: "/order/list/process",
        },
      ],
      orderOs: [
        // {
        //   title: "Order OS",
        //   icon: "content_paste",
        //   value: "/order/os",
        // },
      ],
      incomeMeuns: [],
      profileMenuItem: [
        {
          title: "Change Password",
          icon: "lock",
          value: "/change_password",
        },
        {
          title: "Logout",
          icon: "logout",
          value: "/logout",
        },
      ],
      settingMenuItem: [],
      showOld: false,
      showNew: false,
      logoutModel: false,
      passwordModel: false,
      password: {},
      valid: true,
      passwordOldRule: [(v) => !!v || "Old Password is required"],
      passwordNewRule: [(v) => !!v || "New Password is required"],
      loadingCount: 0,
      loading: false,
      hiddenToolbar: true,
      showDilivery: true,
      drawer: false,
      showMarketing:true,
      drawerList: [],
      uiAccept:{}
    };
  },
  mounted: function () {
    
    if (this.isLogin) {
      this.hiddenToolbar = false;
    } else {
      this.hiddenToolbar = true;
    }
    axios.interceptors.request.use((config) => {
      this.loadingCount++;
      if (!this.loading) {
        this.loading = true;
      }
      return config;
    });
    axios.interceptors.response.use(
      (response) => {
        this.loadingCount--;
        if (this.loadingCount == 0 && this.loading) {
          this.loading = false;
        }
        return response;
      },
      (error) => {
        if (error.isAxiosError && error.message == "Network Error") {
          this.$swal("Check Internet Connection!", error.message, "error");
          this.loadingCount = 1;
          this.loading = false;
        }
        if (error.response.data.status == 401) {
          this.$swal("Authentication Error", "Please Login again!", "error");
          //this.changeRouter("/logout");
          this.logout();
        }
        this.loadingCount--;
        if (this.loadingCount == 0 && this.loading) {
          this.loading = false;
        }
        return Promise.reject(error);
      }
    );
    
  },
  computed: {
    showComputer() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return false;
        case "sm":
          return false;
        case "md":
          return true;
        case "lg":
          return true;
        case "xl":
          return true;
      }
    },
    isLogin: function () {
      let token = this.$store.state.userAccount.password;
      if (token == "") {
        return false;
      } else {
        axios.defaults.headers.common["Authorization"] = `DELI    ${token}`;
        this.uiAcceptMethod();
        return true;
      }
    },
    profileName: function () {
      if (this.$store.state.userAccount == null) {
        return "";
      } else {
        return this.$store.state.userAccount.profileName;
      }
    },
  },
  methods: {
    clickDrawer: function (item) {
      this.drawer = false;
      this.changeRouter(item.value);
    },
    clickHome: function () {
      this.$router
        .push({
          name: "Home",
          query: {
            itemId: this.itemId,
          },
        })
        .catch(() => {});
    },
    cancelChangePassword: function () {
      this.passwordModel = false;
      this.password = {};
    },
    changePassword: function () {
      accountUserService
        .changePassword(this.password.old, this.password.new)
        .then((response) => {
          if (response > 0) {
            this.$swal("Successful", "Change Password", "success");
            this.showPassword = false;
          } else {
            this.$swal("unSuccessful", "Change Password", "error");
          }
          this.password = {
            old: "",
            new: "",
          };
        });
      this.passwordModel = false;
    },
    logout: function () {
      this.$store.commit("updateUserAccount", {
        profileName: "",
        password: "",
        role: "",
      });
      this.changeRouter("/login");
      this.logoutModel = false;
    },
    changeRouter: function (path) {
      if (path == "/logout") {
        this.logoutModel = true;
      } else if (path == "/change_password") {
        this.passwordModel = true;
      } else if (path == "/order/manage") {
        this.$router
          .push({
            name: "manage-order",
            query: {
              itemId: 0,
              step: 1,
            },
          })
          .catch(() => {});
          //location.reload();
      } else if (path == "/order/manageMultiple") {
        this.$router
          .push({
            name: "manage-order-multiple",
            query: {
              itemId: 0,
              step: 1,
            },
          })
          .catch(() => {});
      } else {
        this.$router
          .push({
            path: path,
          })
          .catch(() => {});
      }
    },
    hideToolbar: function (hide) {
      this.hiddenToolbar = hide;
    },
    uiAcceptMethod:function(){
      accountUserService
        .getUiByUserId()
        .then((response) => {
          this.uiAccept = Object.assign({},response);
        })
        .catch((err) => {
          this.$swal("Failed", err.response.data.message, "error");
        });
    }
  },
  watch: {
    isLogin: function (value) {
      if (value) {
        OneSignal.push(() => {
          accountUserService.getOnesignalAccount().then((data) => {
            OneSignal.setExternalUserId(data);
          });
        });
      } else {
        OneSignal.push(function () {
          OneSignal.removeExternalUserId();
        });
      }
    },
    uiAccept:function(){
      this.order.splice(0);
      this.drawerList.splice(0);
      if(this.uiAccept.neworder){
          this.order.push({
          title: "New Order",
          icon: "fiber_new",
          value: "/order/manage",
        });
        this.drawerList.push({
          title: "New Order",
          icon: "fiber_new",
          value: "/order/manage",
        });
      }
      if(this.uiAccept.orderlist){
          this.order.push({
          title: "Order List",
          icon: "assignment_turned_in",
          value: "/order/list/process",
        });
        this.drawerList.push({
          title: "Order List",
          icon: "assignment_turned_in",
          value: "/order/list/process",
        });
      }
      
      this.order.push({
          title: "Task List",
          icon: "assignment",
          value: "/task",
        });
        this.drawerList.push({
          title: "Task List",
          icon: "assignment",
          value: "/task",
        });

        if(this.uiAccept.dailyriderlist){
          this.order.push({
          title: "Daily Rider List",
          icon: "assignment_turned_in",
          value: "/dailyriderlist",
        });
        this.drawerList.push({
          title: "Daily Rider List",
          icon: "assignment_turned_in",
          value: "/dailyriderlist",
        });
      }
      if(this.uiAccept.dailyriderpaylist){
          this.order.push({
          title: "Daily Rider Payment List",
          icon: "assignment_turned_in",
          value: "/dailyriderpaylist",
        });
        this.drawerList.push({
          title: "Daily Rider Payment List",
          icon: "assignment_turned_in",
          value: "/dailyriderpaylist",
        });
      }
      if(this.uiAccept.dailyrestaurantlist){
          this.order.push({
          title: "Daily Restaurant List",
          icon: "assignment_turned_in",
          value: "/dailyrestaurantlist",
        });
        this.drawerList.push({
          title: "Daily Restaurant List",
          icon: "assignment_turned_in",
          value: "/dailyrestaurantlist",
        });
      }
      this.incomeMeuns.splice(0);
      if(this.uiAccept.payment){
          this.incomeMeuns.push({
          title: "Payment",
          icon: "payment",
          value: "/payment",
        });
      }
      if(this.uiAccept.income){
          this.incomeMeuns.push({
          title: "Income",
          icon: "local_atm",
          value: "/income",
        });
      }
      if(this.uiAccept.expense){
          this.incomeMeuns.push({
          title: "Expense",
          icon: "explicit",
          value: "/expense",
        });
      }
      if(this.uiAccept.finance){
          this.incomeMeuns.push({
          title: "Finance",
          icon: "payment",
          value: "/finance",
        });
      }
      this.statement.splice(0);
      if(this.uiAccept.debtorcreditor){
          this.statement.push({
          title: "Debtor/Creditor",
          icon: "swap_horizontal_circle",
          value: "/debtorAndcreditor",
        });
        this.drawerList.push({
          title: "Debtor/Creditor",
          icon: "swap_horizontal_circle",
          value: "/debtorAndcreditor",
        });
      }
      if(this.uiAccept.osdetail){
          this.statement.push({
          title: "OS Detail",
          icon: "chrome_reader_mode",
          value: "/onlineDetailStatement",
        });
        this.drawerList.push({
          title: "OS Detail",
          icon: "chrome_reader_mode",
          value: "/onlineDetailStatement",
        });
      }
      if(this.uiAccept.delivery){
          this.statement.push({
          title: "Delivery",
          icon: "archive",
          value: "/deliveryStatement",
        });
        this.drawerList.push({
          title: "Delivery",
          icon: "archive",
          value: "/deliveryStatement",
        });
      }
      this.report.splice(0);
      if(this.uiAccept.complete){
          this.report.push({
          title: "Complete Report",
          icon: "insert_chart",
          value: "/completeReport",
        });
        this.drawerList.push({
          title: "Complete Report",
          icon: "insert_chart",
          value: "/completeReport",
        });
      }
      if(this.uiAccept.salereport){
          this.report.push({
          title: "Sale Report",
          icon: "show_chart",
          value: "/saleReport",
        });
        this.drawerList.push({
          title: "Sale Report",
          icon: "show_chart",
          value: "/saleReport",
        });
      }
      if(this.uiAccept.incomereport){
          this.report.push({
          title: "Income Report",
          icon: "local_atm",
          value: "/incomeReport",
        });
        this.drawerList.push({
          title: "Income Report",
          icon: "local_atm",
          value: "/incomeReport",
        });
      }
      if(this.uiAccept.expensereport){
          this.report.push({
          title: "Expense Report",
          icon: "explicit",
          value: "/expenseReport",
        });
        this.drawerList.push({
          title: "Expense Report",
          icon: "explicit",
          value: "/expenseReport",
        });
      }
      if(this.uiAccept.profitandloss){
          this.report.push({
          title: "Profit And Loss",
          icon: "payment",
          value: "/profitAndLoss",
        });
        this.drawerList.push({
          title: "Profit And Loss",
          icon: "payment",
          value: "/profitAndLoss",
        });
      }
      if(this.uiAccept.ridertimereport){
          this.report.push({
          title: "Rider's Time",
          icon: "payment",
          value: "/riderTime",
        });
        this.drawerList.push({
          title: "Rider's Time",
          icon: "payment",
          value: "/riderTime",
        });
      }
       if(this.uiAccept.rideranalyzereport){
          this.report.push({
          title: "Rider Analyze",
          icon: "payment",
          value: "/riderAnalyze",
        });
        this.drawerList.push({
          title: "Rider Analyze",
          icon: "payment",
          value: "/riderAnalyze",
        });
      }
      if(this.uiAccept.restanalyzereport){
          this.report.push({
          title: "Restaurant Analyze",
          icon: "payment",
          value: "/restAnalyze",
        });
        this.drawerList.push({
          title: "Restaurant Analyze",
          icon: "payment",
          value: "/restAnalyze",
        });
      }
      this.settingMenuItem.splice(0);
      if(this.uiAccept.dailypercent){
          this.settingMenuItem.push({
          title: "Daily Percent",
          icon: "alarm_add",
          value: "/dailypercent",
        });
        this.drawerList.push({
          title: "Daily Percent",
          icon: "alarm_add",
          value: "/dailypercent",
        });
      }
      if(this.uiAccept.restaurant){
          this.settingMenuItem.push({
          title: "Restaurant",
          icon: "perm_contact_calendar",
          value: "/onlineshopping",
        });
        this.drawerList.push({
          title: "Restaurant",
          icon: "perm_contact_calendar",
          value: "/onlineshopping",
        });
      }
      if(this.uiAccept.useraccount){
          this.settingMenuItem.push({ title: "User Account", icon: "person_add", value: "/account" });
          this.drawerList.push({ title: "User Account", icon: "person_add", value: "/account" });
      }
      if(this.uiAccept.companyprofile){
          this.settingMenuItem.push({
          title: "Company Profile",
          icon: "recent_actors",
          value: "/companyProfile",
        });
        this.drawerList.push({
          title: "Company Profile",
          icon: "recent_actors",
          value: "/companyProfile",
        });
      }
      if(this.$store.state.userAccount.role=='ADMIN'){
          this.settingMenuItem.push({
          title: "Ui Accept",
          icon: "radio_button_unchecked",
          value: "/ui",
        });
        this.drawerList.push({
          title: "Ui Accept",
          icon: "radio_button_unchecked",
          value: "/ui",
        });
      }
      
      this.drawerList.push({
          title: "Change Password",
          icon: "lock",
          value: "/change_password",
        });
      
    }
  },
};
</script>
<style lang="scss">
@import "sass/main.scss";
</style>
<style scope>
html::-webkit-scrollbar {
  width: 10px;
}

html::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.699);
  border-radius: 10px;
}

html::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: #b4b4b4;
  padding: 3px;
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.5);
}

div::-webkit-scrollbar {
  width: 10px;
}

div::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.699);

  border-radius: 3px;
}

div::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: #b4b4b4;
  -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.5);
}
.tbl-info table,
.tbl-info td,
.tbl-info th {
  font-size: 0.8rem !important;
}
.tbl-info thead th,
.tbl-info thead td {
  font-size: 14px;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 3px;
  padding-right: 3px;
  border: 1px solid #e0e0e0;
  background: var(--v-primary-base) !important;
  text-align: center !important;
  color: white !important;
}

.tbl-info tbody th,
.tbl-info tbody td {
  font-size: 13px;
  padding-left: 3px;
  border: 1px solid #e7e7e7;
  padding-right: 1px;
}

</style>
